import React, {useCallback, useEffect, useRef, useState} from 'react'
import './pokazania-uk.scss'
import AccessDenied from '../../components/access-denied/access-denied'
import {useAuth} from '../../contexts/auth'
import {verifyAccess} from '../../utils/admin.utils'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClockRotateLeft, faFileCsv} from "@fortawesome/free-solid-svg-icons";
import DataGrid, {
    Column,
    Pager,
    Paging,
    Toolbar,
    Button as ButtonGrid,
    MasterDetail, FilterRow, HeaderFilter
} from "devextreme-react/data-grid";
import { Workbook } from 'exceljs';
import {Item} from "devextreme-react/toolbar";
import {Button} from "devextreme-react/button";
import { saveAs } from 'file-saver';
import {PopupTitleWithIcon} from "../../components/popup-title-with-icon/popup-title-with-icon";
import ScrollView from "devextreme-react/scroll-view";
import ExtFileUploader from "../../components/file-uploader/file-uploader";
import LoadIndicator from "devextreme-react/load-indicator";
import {Popup} from "devextreme-react/popup";
import notify from "devextreme/ui/notify";
import {createTaskUK, downloadFile, getHistory} from "../../api/point";
import {TextArea} from "devextreme-react";
import {Buffer} from "buffer";
import ZagolovokFromMenu from "../../components/zagolovok/zagolovok";

const PokazaniaUK = () => {
    const { selectedDog } = useAuth()
    const [visiblePage, setVisiblePage] = useState(true)
    const dataGridRef = React.useRef(null);
    const [visibleHelpPopup, setVisibleHelpPopup] = useState(false)
    const [loading, setLoading] = useState(false)
    const extFileUploaderRef = useRef();
    const [fileContent, setFileContent] = useState(null);
    const [history, setHistory] = useState('');
    const [disabledSendButton, setDisabledSendButton] = useState(true);
    const [files, setFiles] = useState([])
    const [visibleTextArea, setVisibleTextArea] = useState(false);

    useEffect(() => {
        const pageRoles = [4]
        setVisiblePage(verifyAccess(pageRoles, selectedDog) && selectedDog.parameter_uk === "1")
    }, [selectedDog])

    useEffect(() => {
        (async function () {
           await loadHistory(selectedDog)
        })()
    }, [selectedDog])

    // загрузка данных
    const loadHistory = async (selDog) => {
        try {
            const result = await getHistory(selDog.kodDog)
            if (result.isOk) { //если успешно создали заявку
                setHistory(result.data)
            } else {
                notify(result.message, 'error', 5000);
            }
        } catch (e) {
            notify(e.message, 'error', 5000);
        } finally {
            setLoading(false)
        }
    }

    /*    useEffect(() => {
            (async function () {
                if (dataGridRef.current && history) {
                    let key = dataGridRef.current?.instance.getKeyByRowIndex(0)
                    setKey(key)
                    dataGridRef.current.instance.expandRow(key)
                }
            })()
        }, [history, dataGridRef.current, key])*/

    // Функция экспорта в Excel
    const onExporting = () => {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Данные выгрузки');

        // Заголовки колонок
        worksheet.columns = [
            { header: 'Дата загрузки в ЛК', key: 't_added', width: 22 },
            { header: 'Имя файла', key: 'filename', width: 36 },
            { header: 'Дата результата', key: 'd_m', width: 22 },
            { header: 'Статус', key: 'status', width: 20 },
            { header: 'Сообщение', key: 'msg', width: 50 }
        ];

        // Стили для заголовков
        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        headerRow.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF0078D7' }
        };

        // Добавляем данные
        history.forEach(item => {
            worksheet.addRow({
                id: item.id,
                t_added: item.t_added ? new Date(item.t_added).toLocaleString() : '',
                filename: item.filename,
                d_m: item.d_m ? new Date(item.d_m).toLocaleString() : '',
                status: item.status,
                kod_dog: item.kod_dog,
                msg: item.msg
            });
        });

        // Авто-ширина колонок (кроме msg)
        worksheet.columns.forEach(column => {
            if (column.key !== 'msg') {
                column.width = Math.max(
                    10,
                    Math.min(
                        50,
                        column.values.reduce(
                            (max, value) => Math.max(max, (value?.toString()?.length || 0)),
                            0
                        ) + 2
                    )
                );
            }
        });

        // Сохраняем файл
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Выгрузка_данных.xlsx');
        });
    };

    const onShowPopup = async () => {
        setVisibleHelpPopup(true)
    }

    function hidingPopup() {
        setVisibleHelpPopup(false)
    }

    const onSendRequest = async () => {

        setLoading(true)
        const fd = new FormData()
        fd.append("kod_dog",selectedDog.kodDog)
        fd.append("Ndog",selectedDog.ndog)
        //прикрепляем к заявке вложения
        if (files) {
            for (let i = 0; i < files.length; i++) {
                fd.append('file', files[i])
            }
        } else {
            notify('Прикрепите файл', 'error', 5000);
        }
        try {
            const result = await createTaskUK(fd)
            if (result.isOk) { //если успешно создали заявку
                setVisibleHelpPopup(false)
                extFileUploaderRef.current.clearAttachFiles();
                notify(result.message, 'success', 5000)
                setFiles([])
                setVisibleTextArea(false)
                setDisabledSendButton(true)
            } else {
                notify(result.message, 'error', 5000);
            }
        } catch (e) {
            notify(e.message, 'error', 5000);
        } finally {
            setLoading(false)
            setFileContent(null)

        }
    }

    const onClickClearUpload = () => {
        setDisabledSendButton(true)
        setFileContent(null)
        setVisibleTextArea(false)
    }

    const onValueChanged = async (e) => {
        if (e.length === 0){
            setFileContent(null)
            setVisibleTextArea(false)
            return
        }
        setFiles(e)
        const file = e[0]; // Получаем первый выбранный файл
        let errortext = null
        if (!file.name.includes('_')) {
            errortext = 'Имя файла не содержит ИНН.\r\n\r\n';
        }

        let inn = file.name.slice(0,10)
        if (!errortext && +inn !== +selectedDog.inn) {
            let errINN = 'ИНН в файле не совпадает с ИНН договора.\r\n\r\n';
            errortext = !errortext ? errINN : errortext + errINN;
        }

        let t = await isUtf8File(file)
        if (!t) {
            let errUtf8 = 'Файл не в кодировке UTF-8. Пожалуйста, используйте UTF-8.\r\n\r\n';
            errortext = !errortext ? errUtf8 : errortext + errUtf8;
        }


        const reader = new FileReader();
        reader.onload = (event) => {
            setFileContent(errortext || event.target.result);
            setVisibleTextArea(true)
            if (errortext) {
                setDisabledSendButton(true)
                setFiles([])
            } else {
                setDisabledSendButton(false)
            }
        };
        reader.readAsText(file);
    }

    const isUtf8File = async (file) => {
        const arrayBuffer = await file.arrayBuffer();
        const view = new Uint8Array(arrayBuffer);
        // Проверка BOM
        if (view.length >= 3 && view[0] === 0xEF && view[1] === 0xBB && view[2] === 0xBF) {
            return true
        }
        // Попробуем читать как UTF-8
        try {
            const decoder = new TextDecoder('utf-8', { fatal: true });
            const decoded = decoder.decode(new Uint8Array(arrayBuffer));
            // Проверим, что нет "замены" () из-за некорректных символов
            if (!decoded.includes('\uFFFD')) {
                return true
            }
        } catch (e) {
            // Ошибка при декодировании → не UTF-8
            return false
        }
        return false
    };

    const onDownloadFile = useCallback((e) => {
        (async function(){
            const guid = e.row.data.guid
            setLoading(true)
            const res = await downloadFile(guid)
            if (res.isOk){
                const file = res.data.data.data
                const filename = res.data.headers['content-disposition'].replaceAll(/.*filename=([^;]+).*/gm,'$1')
                let fileDownload = require('js-file-download')
                fileDownload(Buffer.from(file), filename)
            } else notify(res.message,'error',5000)
            setLoading(false)
        })()

    }, []);

    const onContentReady = useCallback((e) => {
        (async function(){
            if (!e.component.getSelectedRowKeys().length && dataGridRef.current) {
                /*let key = dataGridRef.current?.instance.getKeyByRowIndex(0)
                dataGridRef.current.instance.expandRow(key)*/
            }
        })()
    }, []);

    /*    const onRowClick = (e) => {
            let key = e.key;
            let expanded = e.component.isRowExpanded(key);
            if (expanded) {
                e.component.collapseRow(key);
            }
            else {
                e.component.expandRow(key);
            }
        }*/

    const onExpandAll = () => {
        if (dataGridRef.current && history) {
            history.forEach((item) => {
                dataGridRef.current.instance.expandRow(item.id); // или index, в зависимости от keyExpr
            });
        }
    };

    const onCollapseAll = () => {
        dataGridRef.current?.instance.collapseAll(-1);
    }

    const onRefresh = async () => {
        await loadHistory(selectedDog);
    }

    const renderDetail = (props) => {
        const { msg } = props.data;
        return (
            <div className="employee-info flex-wrap">
                <b><p>Результат:</p></b>
                <p className="employee-notes">{msg ? msg : 'Отсутствует'}</p>
            </div>
        );
    };

    return (
        <>{visiblePage ?
            <div className={'content-block dx-card responsive-paddings big-input'}>
                <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faClockRotateLeft} />
                <h3><strong><ZagolovokFromMenu/></strong></h3>
                <DataGrid
                    id="grid-container"
                    ref={dataGridRef}
                    dataSource={history}
                    keyExpr="id"
                    columnHidingEnabled={false}
                    allowColumnReordering={true}
                    rowAlternationEnabled={true}
                    showBorders={true}
                    noDataText="Нет данных"
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    width={'100%'}
                    //onRowClick={onRowClick}
                    onContentReady={onContentReady}

                >
                    {/* <GroupPanel visible={true} /> */}
                    {/* <SearchPanel visible={true} highlightCaseSensitive={true} /> */}
                    {/*<Selection mode='single' />*/}
                    <Pager allowedPageSizes={'auto'} showPageSizeSelector={true} />
                    <Paging defaultPageSize={10} />
                    <FilterRow
                        visible={true} />
                    <HeaderFilter visible={true} />
                    <Toolbar>
                        <Item location="before" locateInMenu="auto">
                            <Button hint="Отправить показания (csv)" text="Отправить показания (csv)" icon="export" onClick={onShowPopup} />
                        </Item>
                        <Item location="before" locateInMenu="auto">
                            <Button icon='exportxlsx' className='w-100' hint='Выгрузить таблицу в Excel' text='Выгрузить таблицу в Excel' onClick={onExporting}/>
                        </Item>
                        <Item location="before" showText={'inMenu'} locateInMenu="auto">
                            <Button  icon='expand' className='w-100' hint={'Развернуть все строки'} onClick={onExpandAll}/>
                        </Item>
                        <Item location="before" showText={'inMenu'} text={'Свенуть все строки'} locateInMenu="auto">
                            <Button  icon='collapse' className='w-100' hint={'Свенуть все строки'}  onClick={onCollapseAll}/>
                        </Item>
                        <Item location="before" showText={'inMenu'} text={'Обновить данные в таблице'} locateInMenu="auto">
                            <Button  icon='refresh' className='w-100' hint={'Обновить данные в таблице'}  onClick={onRefresh}/>
                        </Item>
                    </Toolbar>

                    <Column type="buttons" caption="Скачать"  width={75} >
                        <ButtonGrid id='download' hint="Скачать" icon="download" onClick={(e) => onDownloadFile(e)} />
                    </Column>
                    <Column dataField="filename" caption="Имя файла" dataType="string" />
                    <Column dataField="t_added" caption="Дата загрузки в ЛК" format="dd.MM.yyyy HH:mm" dataType="date" width={150}/>
                    <Column dataField="status" caption="Статус" dataType="string" width={250} />
                    <Column dataField="d_m" caption="Дата результата" format="dd.MM.yyyy HH:mm" dataType="date"  width={150} />
                    <MasterDetail dataField="msg" enabled={true} render={renderDetail} />
                </DataGrid>
                <Popup
                    id="help-popup"
                    visible={visibleHelpPopup}
                    onHiding={hidingPopup}
                    hideOnOutsideClick={false}
                    height='auto'
                    maxHeight="800px" //форма с прибором не входит никак иначе
                    maxWidth="600px"
                    title="Отправить показания УК"
                    showCloseButton={true}
                    titleRender={()=>PopupTitleWithIcon(faFileCsv, "Отправить показания УК",hidingPopup)}
                >
                    <ScrollView width='100%' height='100%' className={'popupWithUploader'}>
                        <div><ExtFileUploader ref={extFileUploaderRef} onClickClearUpload={() => onClickClearUpload()} typeFileLimit='ukPokaz' setfile={(e) => onValueChanged(e) }></ExtFileUploader>
                            {visibleTextArea &&
                                <TextArea
                                    className='mt-4'
                                    height={120}
                                    value={fileContent}
                                    readOnly={true}
                                />}

                            <Button className='mt-4'
                                    type={'default'}
                                    text="Отправить показания"
                                    icon="email"
                                    onClick={onSendRequest}
                                    disabled={disabledSendButton}
                            />
                        </div>
                        <LoadIndicator width={'24px'} height={'24px'} visible={loading}/>
                    </ScrollView>
                </Popup>
            </div>
            : <AccessDenied/>}</>
    )

}

export default PokazaniaUK
